import { IconButton } from '@mui/material';
import WhatsApp from '../../../../../../assets/icons/social-media/whatsapp.svg?url';
import Facebook from '../../../../../../assets/icons/social-media/facebook.svg?url';
import Mobile from '../../../../../../assets/icons/social-media/mobile.svg?url';
import { isMobile } from 'react-device-detect';
import { redirecTo, openNewTabAndFocus } from '../../../../../../utils';
import l from '../../../../../../lang';
import './styles.scss';
import { Tooltip } from '../../../../../common/tooltip';
import { segmentShareOpenLink } from '../../../../../../utils/analytics';
import { useDashboard } from '../../../../../../store/dashboard';

interface ShareButtonsProps {
  link: string;
  validReferrer: boolean;
  onCopy?: () => void;
}

const ShareButtons = ({ link, validReferrer, onCopy }: ShareButtonsProps) => {
  const { merchantMe, userMe } = useDashboard();

  const sendSegmentEvent = (channel: string) => {
    if (merchantMe && userMe) {
      segmentShareOpenLink({ channel, valid: validReferrer ? 1 : 0, merchantId: merchantMe.id, userId: userMe.id });
    }
  };

  const onWhatsAppHandler = () => {
    sendSegmentEvent('whatsapp');
    if (!validReferrer) {
      onCopy?.();
      return;
    }

    if (isMobile) {
      redirecTo(`https://wa.me/?text=${l('openPaymentLink.shareLink')} ${link}&utm_medium=whatsapp`);
    } else {
      openNewTabAndFocus(`https://web.whatsapp.com/send?text=${l('openPaymentLink.shareLink')} ${link}&utm_medium=whatsapp`);
    }
  };

  const onFacebookHandler = () => {
    sendSegmentEvent('facebook');
    if (!validReferrer) {
      onCopy?.();
      return;
    }

    openNewTabAndFocus(`http://www.facebook.com/sharer/sharer.php?u=${link}&utm_medium=facebook`);
  };

  const onMobileHandler = () => {
    sendSegmentEvent('mobile');
    if (!validReferrer) {
      onCopy?.();
      return;
    }

    navigator
      .share({
        title: l('affiliations.shareLink'),
        url: `${link}&utm_medium=mobile`,
      })
      .then(() => {})
      .catch(err => {});
  };

  return (
    <div className="share-open-link-buttons">
      <div className="share-open-link-buttons__content">
        <div className="share-open-link-buttons__buton">
          <Tooltip title="Whatsapp">
            <IconButton onClick={onWhatsAppHandler}>
              <img src={WhatsApp} />
            </IconButton>
          </Tooltip>
        </div>
        <div className="share-open-link-buttons__buton">
          <Tooltip title="Facebook">
            <IconButton onClick={onFacebookHandler}>
              <img src={Facebook} />
            </IconButton>
          </Tooltip>
        </div>
        {
          // @ts-ignore
          navigator.share && (
            <div className="share-open-link-buttons__buton">
              <IconButton onClick={onMobileHandler}>
                <img src={Mobile} />
              </IconButton>
              <div className="share-open-link-buttons__desc">{l('paymentLink.shareLink.moreOptions')}</div>
            </div>
          )
        }
      </div>
    </div>
  );
};

export default ShareButtons;
